// AUTO-GENERATED by tools/generate-parallel.mjs --world 12. Do not edit by hand.
// Regenerate with: node tools/generate-parallel.mjs --world 12
// W12 (Vault) — second expansion. 2 locked tiles per color; d=7 floor.
// // Pre-generated for drip-release during Closed Testing window.
import type { LevelDef } from '@tessera/engine';

export const WORLD_12_GENERATED: LevelDef[] = [
  // d*=7  branching=11.63  D=0.107  tiles=14
  {
    id: 'w12-l01',
    world: 12,
    index: 1,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 9 },
    tiles: [
    { coord: { q: 3, r: -1 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 3 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: -3 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -1, r: 0 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 1 }, color: 0, state: { kind: 'locked', key: 0 } },
    { coord: { q: -3, r: 0 }, color: 0 },
    { coord: { q: -3, r: 2 }, color: 0, state: { kind: 'locked', key: 0 } },
    { coord: { q: 2, r: -3 }, color: 1 },
    { coord: { q: 3, r: -3 }, color: 1, state: { kind: 'locked', key: 1 } },
    { coord: { q: 3, r: -2 }, color: 1, state: { kind: 'locked', key: 1 } },
    { coord: { q: 1, r: 2 }, color: 2, state: { kind: 'locked', key: 2 } },
    { coord: { q: -1, r: 3 }, color: 2, state: { kind: 'locked', key: 2 } },
    { coord: { q: 2, r: 1 }, color: 3, state: { kind: 'locked', key: 3 } },
    { coord: { q: 0, r: 3 }, color: 3, state: { kind: 'locked', key: 3 } },
    ],
  },
  // d*=8  branching=8.37  D=0.351  tiles=15
  {
    id: 'w12-l02',
    world: 12,
    index: 2,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 10 },
    tiles: [
    { coord: { q: -3, r: 0 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: 3 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -3 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -2, r: 2 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: 0 }, color: 4, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: 0 }, color: 0, state: { kind: 'locked', key: 0 } },
    { coord: { q: 3, r: -1 }, color: 0, state: { kind: 'locked', key: 0 } },
    { coord: { q: 0, r: -3 }, color: 1, state: { kind: 'locked', key: 1 } },
    { coord: { q: 1, r: -3 }, color: 1, state: { kind: 'locked', key: 1 } },
    { coord: { q: -3, r: 3 }, color: 2, state: { kind: 'locked', key: 2 } },
    { coord: { q: -2, r: 3 }, color: 2, state: { kind: 'locked', key: 2 } },
    { coord: { q: 2, r: -3 }, color: 3, state: { kind: 'locked', key: 3 } },
    { coord: { q: 3, r: -2 }, color: 3, state: { kind: 'locked', key: 3 } },
    { coord: { q: -3, r: 2 }, color: 4, state: { kind: 'locked', key: 4 } },
    { coord: { q: -1, r: -2 }, color: 4, state: { kind: 'locked', key: 4 } },
    ],
  },
  // d*=8  branching=8.52  D=0.404  tiles=13
  {
    id: 'w12-l03',
    world: 12,
    index: 3,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 10 },
    tiles: [
    { coord: { q: -3, r: 1 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -1 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: 3 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 1, r: -3 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -2 }, color: 0, state: { kind: 'locked', key: 0 } },
    { coord: { q: 3, r: -3 }, color: 0 },
    { coord: { q: 3, r: 0 }, color: 0, state: { kind: 'locked', key: 0 } },
    { coord: { q: -3, r: 2 }, color: 1, state: { kind: 'locked', key: 1 } },
    { coord: { q: -3, r: 0 }, color: 1, state: { kind: 'locked', key: 1 } },
    { coord: { q: 0, r: -3 }, color: 2, state: { kind: 'locked', key: 2 } },
    { coord: { q: -1, r: -2 }, color: 2, state: { kind: 'locked', key: 2 } },
    { coord: { q: -2, r: 3 }, color: 3, state: { kind: 'locked', key: 3 } },
    { coord: { q: -3, r: 3 }, color: 3, state: { kind: 'locked', key: 3 } },
    ],
  },
  // d*=8  branching=9.98  D=0.415  tiles=13
  {
    id: 'w12-l04',
    world: 12,
    index: 4,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 10 },
    tiles: [
    { coord: { q: 3, r: -3 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -1, r: 3 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -2, r: -1 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: 0 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -2, r: 3 }, color: 0, state: { kind: 'locked', key: 0 } },
    { coord: { q: -3, r: 2 }, color: 0, state: { kind: 'locked', key: 0 } },
    { coord: { q: -3, r: 3 }, color: 0 },
    { coord: { q: 1, r: -3 }, color: 1, state: { kind: 'locked', key: 1 } },
    { coord: { q: 2, r: -3 }, color: 1, state: { kind: 'locked', key: 1 } },
    { coord: { q: 0, r: 3 }, color: 2, state: { kind: 'locked', key: 2 } },
    { coord: { q: 1, r: 2 }, color: 2, state: { kind: 'locked', key: 2 } },
    { coord: { q: -3, r: 1 }, color: 3, state: { kind: 'locked', key: 3 } },
    { coord: { q: -1, r: -2 }, color: 3, state: { kind: 'locked', key: 3 } },
    ],
  },
  // d*=8  branching=12.29  D=0.417  tiles=15
  {
    id: 'w12-l05',
    world: 12,
    index: 5,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 10 },
    tiles: [
    { coord: { q: 3, r: -3 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 1 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: 3 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: -2 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 1, r: 0 }, color: 4, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 3 }, color: 0, state: { kind: 'locked', key: 0 } },
    { coord: { q: -3, r: 2 }, color: 0, state: { kind: 'locked', key: 0 } },
    { coord: { q: 3, r: -2 }, color: 1, state: { kind: 'locked', key: 1 } },
    { coord: { q: 3, r: 0 }, color: 1, state: { kind: 'locked', key: 1 } },
    { coord: { q: 2, r: -3 }, color: 2, state: { kind: 'locked', key: 2 } },
    { coord: { q: 0, r: -3 }, color: 2, state: { kind: 'locked', key: 2 } },
    { coord: { q: 1, r: 2 }, color: 3, state: { kind: 'locked', key: 3 } },
    { coord: { q: -1, r: 3 }, color: 3, state: { kind: 'locked', key: 3 } },
    { coord: { q: -2, r: -1 }, color: 4, state: { kind: 'locked', key: 4 } },
    { coord: { q: -1, r: -2 }, color: 4, state: { kind: 'locked', key: 4 } },
    ],
  },
  // d*=8  branching=12.58  D=0.419  tiles=14
  {
    id: 'w12-l06',
    world: 12,
    index: 6,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 10 },
    tiles: [
    { coord: { q: -3, r: 3 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: 0 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: -3 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -3 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: -3 }, color: 0, state: { kind: 'locked', key: 0 } },
    { coord: { q: 3, r: -2 }, color: 0, state: { kind: 'locked', key: 0 } },
    { coord: { q: 1, r: -3 }, color: 0 },
    { coord: { q: -1, r: -2 }, color: 1 },
    { coord: { q: -3, r: 2 }, color: 1, state: { kind: 'locked', key: 1 } },
    { coord: { q: -3, r: 0 }, color: 1, state: { kind: 'locked', key: 1 } },
    { coord: { q: 1, r: 2 }, color: 2, state: { kind: 'locked', key: 2 } },
    { coord: { q: 0, r: 3 }, color: 2, state: { kind: 'locked', key: 2 } },
    { coord: { q: -3, r: 1 }, color: 3, state: { kind: 'locked', key: 3 } },
    { coord: { q: -2, r: 3 }, color: 3, state: { kind: 'locked', key: 3 } },
    ],
  },
  // d*=8  branching=10.43  D=0.436  tiles=14
  {
    id: 'w12-l07',
    world: 12,
    index: 7,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 10 },
    tiles: [
    { coord: { q: 1, r: -3 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -1, r: 3 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 1 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: 0 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 3 }, color: 0 },
    { coord: { q: 0, r: 3 }, color: 0, state: { kind: 'locked', key: 0 } },
    { coord: { q: -2, r: 3 }, color: 0, state: { kind: 'locked', key: 0 } },
    { coord: { q: 0, r: -3 }, color: 1, state: { kind: 'locked', key: 1 } },
    { coord: { q: 3, r: -3 }, color: 1 },
    { coord: { q: 2, r: -3 }, color: 1, state: { kind: 'locked', key: 1 } },
    { coord: { q: 3, r: -2 }, color: 2, state: { kind: 'locked', key: 2 } },
    { coord: { q: 3, r: -1 }, color: 2, state: { kind: 'locked', key: 2 } },
    { coord: { q: -3, r: 0 }, color: 3, state: { kind: 'locked', key: 3 } },
    { coord: { q: -2, r: -1 }, color: 3, state: { kind: 'locked', key: 3 } },
    ],
  },
  // d*=8  branching=9.89  D=0.455  tiles=14
  {
    id: 'w12-l08',
    world: 12,
    index: 8,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 10 },
    tiles: [
    { coord: { q: 3, r: -2 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 2 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: 3 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: -3 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 1 }, color: 0, state: { kind: 'locked', key: 0 } },
    { coord: { q: -3, r: 0 }, color: 0, state: { kind: 'locked', key: 0 } },
    { coord: { q: -3, r: 3 }, color: 0 },
    { coord: { q: 3, r: -3 }, color: 1, state: { kind: 'locked', key: 1 } },
    { coord: { q: 3, r: -1 }, color: 1, state: { kind: 'locked', key: 1 } },
    { coord: { q: 3, r: 0 }, color: 1 },
    { coord: { q: 1, r: -3 }, color: 2, state: { kind: 'locked', key: 2 } },
    { coord: { q: -1, r: -2 }, color: 2, state: { kind: 'locked', key: 2 } },
    { coord: { q: -2, r: 3 }, color: 3, state: { kind: 'locked', key: 3 } },
    { coord: { q: -1, r: 3 }, color: 3, state: { kind: 'locked', key: 3 } },
    ],
  },
  // d*=8  branching=9.84  D=0.465  tiles=14
  {
    id: 'w12-l09',
    world: 12,
    index: 9,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 10 },
    tiles: [
    { coord: { q: 0, r: 3 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -3 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 0 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 3 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: -3 }, color: 0 },
    { coord: { q: 0, r: -3 }, color: 0, state: { kind: 'locked', key: 0 } },
    { coord: { q: 1, r: -3 }, color: 0, state: { kind: 'locked', key: 0 } },
    { coord: { q: -3, r: 1 }, color: 1 },
    { coord: { q: -1, r: 3 }, color: 1, state: { kind: 'locked', key: 1 } },
    { coord: { q: -2, r: 3 }, color: 1, state: { kind: 'locked', key: 1 } },
    { coord: { q: 3, r: 0 }, color: 2, state: { kind: 'locked', key: 2 } },
    { coord: { q: 3, r: -1 }, color: 2, state: { kind: 'locked', key: 2 } },
    { coord: { q: 3, r: -2 }, color: 3, state: { kind: 'locked', key: 3 } },
    { coord: { q: 0, r: -2 }, color: 3, state: { kind: 'locked', key: 3 } },
    ],
  },
];
